import React, { useState } from "react";
import { processService } from "../../services/process.service";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Card } from "../ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "../ui/dialog";
import { Label } from "../ui/label";
import { toast } from "sonner";
import { Plus, Trash, User } from "lucide-react";

const { addProcessoSigner, removeProcessoSigner } = processService;

export function SignersTab({ processo, onRefresh }) {
  const [isSignerDialogOpen, setIsSignerDialogOpen] = useState(false);
  const [newSignerData, setNewSignerData] = useState({
    name: "", email: "", role: "", phone_number: ""
  });

  const handleAddSigner = async () => {
    if (!processo) return;
    try {
      await addProcessoSigner(processo.id, newSignerData);
      toast.success("Assinante adicionado");
      setIsSignerDialogOpen(false);
      setNewSignerData({ name: "", email: "", role: "", phone_number: "" });
      onRefresh();
    } catch (e) {
      toast.error("Erro ao adicionar assinante: " + e.message);
    }
  };

  const handleRemoveSigner = async (signerId) => {
    if (!processo) return;
    try {
      await removeProcessoSigner(processo.id, signerId);
      toast.success("Assinante removido");
      onRefresh();
    } catch (e) {
      toast.error("Erro ao remover assinante");
    }
  };

  return (
    <Card className="p-6">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-xl font-semibold flex items-center gap-2">
          <User className="h-5 w-5" /> Assinantes (Advogados/Testemunhas)
        </h3>
        <Dialog open={isSignerDialogOpen} onOpenChange={setIsSignerDialogOpen}>
          <DialogTrigger asChild>
            <Button size="sm"><Plus className="mr-2 h-4 w-4" /> Adicionar Assinante</Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Adicionar Assinante</DialogTitle>
            </DialogHeader>
            <div className="space-y-4 py-4">
              <div className="space-y-2">
                <Label>Nome</Label>
                <Input
                  value={newSignerData.name}
                  onChange={e => setNewSignerData({ ...newSignerData, name: e.target.value })}
                />
              </div>
              <div className="space-y-2">
                <Label>Email</Label>
                <Input
                  value={newSignerData.email}
                  onChange={e => setNewSignerData({ ...newSignerData, email: e.target.value })}
                />
              </div>
              <div className="space-y-2">
                <Label>Papel (Role)</Label>
                <Input
                  value={newSignerData.role}
                  onChange={e => setNewSignerData({ ...newSignerData, role: e.target.value })}
                  placeholder="ex: Advogado"
                />
              </div>
              <div className="space-y-2">
                <Label>Telefone</Label>
                <Input
                  value={newSignerData.phone_number}
                  onChange={e => setNewSignerData({ ...newSignerData, phone_number: e.target.value })}
                  placeholder="Apenas números (Necessário para WhatsApp)"
                />
              </div>
            </div>
            <DialogFooter>
              <Button onClick={handleAddSigner}>Salvar</Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>

      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Nome</TableHead>
            <TableHead>Email</TableHead>
            <TableHead>Papel</TableHead>
            <TableHead className="text-right">Ações</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {processo.signers?.map(signer => (
            <TableRow key={signer.id}>
              <TableCell>{signer.name}</TableCell>
              <TableCell>{signer.email}</TableCell>
              <TableCell>{signer.role}</TableCell>
              <TableCell className="text-right">
                <Button variant="ghost" size="sm" onClick={() => handleRemoveSigner(signer.id)}>
                  <Trash className="h-4 w-4 text-red-500" />
                </Button>
              </TableCell>
            </TableRow>
          ))}
          {processo.signers?.length === 0 && (
            <TableRow>
              <TableCell colSpan={4} className="text-center text-gray-500">Nenhum assinante cadastrado</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Card>
  );
}
